export const SONGS = [
    "2nd Grade",
    "Dope",
    "I Know (RM & JK)",
    "I Need U",
    "DDaeng",
    "Boy With Luv (Feat. Halsey)",
    "Moving On",
    "Outro: Her",
    "00:00 (Zero O’Clock)",
    "Blue & Grey",
    "Autumn Leaves",
    "4 O'Clock",
    "Promise",
    "Rain",
    "Butter",
    "Telepathy",
    "Reflection",
    "Trivia 轉 : Seesaw",
    "Lost",
    "Hope World",
    "Heartbeat (BTS World Original Soundtrack)",
    "Mikrokosmos",
    "Silver Spoon",
    "House of Cards - Full Length Edition",
    "Inner Child",
    "We are Bulletproof : the Eternal",
    "War of Hormone",
    "Burn It (feat. MAX)",
    "forever rain",
    "Epiphany",
    "Paldogangsan",
    "Airplane pt.2",
    "So Far Away",
    "Let Me Know",
    "Dynamite",
    "tokyo",
    "With You",
    "Boy in Luv",
    "21st Century Girl",
    "Dream Glow (BTS World Original Soundtrack) [Pt. 1]",
    "MIC Drop",
    "Not Today",
    "Filter",
    "Snow Flower",
    "uhgood",
    "Daechwita",
    "Abyss",
    "Answer : Love Myself",
    "Spine Breaker",
    "Where You From",
    "BTS Cypher 4",
    "I'm Fine",
    "Intro: Skool Luv Affair",
    "Stay",
    "FAKE LOVE",
    "Just One Day",
    "Iine!",
    "Daydream (백일몽)",
    "Interlude : Shadow",
    "Don't Leave Me",
    "Boy in Luv",
    "Lights",
    "724148",
    "Dis-ease",
    "always",
    "If I Ruled the World",
    "DNA",
    "My Time",
    "Life Goes On",
    "N.O",
    "Iine!Pt.2 - Ano Bashode -",
    "Airplane",
    "First Love",
    "BTS Cypher Pt.2: Triptych",
    "Spine Breaker",
    "Bicycle",
    "UGH!",
    "Tonight",
    "Crying Over You ◐ (feat. RM & BEKA)",
    "Outro: Propose",
    "Intro : Persona",
    "Intro: Serendipity",
    "Just One Day",
    "Throw Away",
    "Outro : Ego",
    "Interlude : Set me free",
    "Christmas Tree",
    "Friends",
    "Begin",
    "HOME",
    "MAMA",
    "Whalien 52",
    "2! 3!",
    "Permission to Dance",
    "Best Of Me",
    "Wake Up",
    "Crystal Snow",
    "Pied Piper",
    "Jump",
    "Scenery",
    "Jump",
    "Ma City",
    "Monster",
    "24/7=Heaven",
    "The Stars",
    "Base Line",
    "Love Maze",
    "Miss Right",
    "Black Swan",
    "Wishing On A Star",
    "Life",
    "Awake",
    "Good Day",
    "People",
    "IDOL",
    "Fly To My Room",
    "WINTER FLOWER(Feat.RM)",
    "Strange (feat. RM)",
    "28 (feat. NiiHWA)",
    "everythingoes",
    "Respect",
    "Magic Shop",
    "Lie",
    "Dynamite",
    "Change",
    "What do you think?",
    "BTS Cypher Pt.1",
    "Sweet Night",
    "Outro: Propose",
    "Outro: Wings",
    "SUGA's Interlude",
    "Stay Gold",
    "Dear my friend (feat. Kim Jong Wan of NELL)",
    "Love Is Not Over - Full Length Edition",
    "134340",
    "For You",
    "Run",
    "Outro: Luv in Skool",
    "Dionysus",
    "Intro: Boy Meets Evil",
    "항상 (HANGSANG)",
    "Born Singer",
    "Christmas Love",
    "Anpanman",
    "Blue Side (Outro)",
    "Blueberry Eyes (feat. SUGA of BTS)",
    "Paradise",
    "We Are Bulletproof Pt.2",
    "Blood Sweat & Tears",
    "Am I Wrong",
    "Joke",
    "Intro: 2 Cool 4 Skool",
    "Look Here",
    "Tony Montana",
    "My Universe",
    "Boyz with Fun",
    "Intro.",
    "We On",
    "Outro.",
    "BTS Cypher Pt.3: Killer",
    "BTS Cypher Pt.2: Triptych",
    "140503 at Dawn",
    "Could You Turn off Your Cell Phone",
    "moonchild",
    "Tomorrow",
    "No More Dream",
    "seoul (prod. HONNE)",
    "Butterfly",
    "Interlude_dream, Reality",
    "A Supplementary Story: You Never Walk Alone",
    "FAKE LOVE - Rocking Vibe Mix",
    "Champion - Remix",
    "ON",
    "Your eyes tell",
    "The Truth Untold (feat. Steve Aoki)",
    "Stay Alive (Prod. SUGA of BTS)",
    "Super Tuna",
    "Tomorrow",
    "Attack on Bangtan",
    "Good Day",
    "Make It Right",
    "Moon",
    "Adrift",
    "Do You",
    "Give It to Me",
    "dimple",
    "Intro: O!RUL8,2?",
    "eight(Prod.&Feat. SUGA of BTS)",
    "Don't (feat. RM)",
    "Coffee",
    "Stigma",
    "Moonlight",
    "So What",
    "Chicken Noodle Soup (feat. Becky G)",
    "Euphoria",
    "Yours",
    "Epilogue: Young Forever",
    "The Last",
    "Outro: Circle Room Cypher",
    "Hip Hop Phile",
    "Honsool",
    "Winter Bear",
    "Outro: Tear",
    "Outro: Do You Think It Makes Sense?",
    "Louder than bombs",
    "Still With You",
    "badbye",
    "Go Go",
    "All Night (BTS World Original Soundtrack) [Pt. 3]",
    "Intro: The Most Beautiful Moment in Life",
    "Film out",
    "Danger",
    "For You",
    "Hold Me Tight",
    "A Brand New Day (BTS World Original Soundtrack) [Pt. 2]",
    "Save Me",
    "It's Definitely You",
    "Trivia 起 : Just Dance",
    "Waste It On Me",
    "Burning Up (Fire)",
    "Trivia 承 : Love",
    "Black Swan",
    "Intro: Never Mind",
    "Butter (Holiday Remix)",
    "Spring Day",
    "Jamais Vu",
    "Intro: Singularity",
    "Embarrassed",
    "Converse High",
    "Like",
    "Intro: Skool Luv Affair",
    "Let Go",
    "Intro: What Am I to You"
]
